// In-game floating-text phrases (no React) so the engine can stay framework-free.
export const GAME_STRINGS = {
  es: {
    protegido: "¡PROTEGIDO!",
    ay: "¡AY!",
    meta: "¡META!",
    plop: "¡PLOP!",
    fuerza: "¡FUERZA!",
    zoom: "¡ZOOM!",
    golpe: "¡GOLPE!",
    jefa: "¡LA JEFA!",
    salud: "¡SALUD!",
    provecho: "¡BUEN PROVECHO!",
    pow: "¡POW!",
    baila: "¡BAILA!",
    fiestaMode: "¡MODO FIESTA!",
    finFiesta: "fin fiesta",
    police: "¡POLICÍA! ¡SALTÁ!",
    plusFiesta: "+FIESTA",
    enrage: "¡ENOJADA!",
    embiste: "¡EMBISTE!",
    karate: "¡KARATAZO!",
    machete: "¡MACHETAZO!",
    maraca: "¡MARACAZO!",
    spin: "¡GIRO!",
    headbutt: "¡CABEZAZO!",
    rock: "¡PEDRADA!",
    ball: "¡BALONAZO!",
    notes: "¡NOTAS!",
    fritanga: "¡FRITANGAZO!",
    nacatamal: "¡NACATAMALAZO!",
    coconut: "¡Cocazo!",
    bread: "¡PANAZO!",
    electric: "¡GANCHO DERECHO!",
    hypno: "¡PUÑO HIPNÓTICO!",
    carriage: "¡CARRUAJE! ¡SALTÁ!",
    tuktuk: "¡TUK TUK! ¡SALTÁ!",
    maypole: "¡PALO DE MAYO! ¡SALTÁ!",
    moto: "¡MOTO! ¡SALTÁ!",
    adHere: "PUBLICIDAD AQUÍ",
    adSub: "tu marca · nicabros.com",
  },
  en: {
    protegido: "PROTECTED!",
    ay: "OUCH!",
    meta: "GOAL!",
    plop: "SPLASH!",
    fuerza: "SMASH!",
    zoom: "ZOOM!",
    golpe: "HIT!",
    jefa: "THE BOSS!",
    salud: "CHEERS!",
    provecho: "¡BUEN PROVECHO!",
    pow: "POW!",
    baila: "DANCE!",
    fiestaMode: "FIESTA MODE!",
    finFiesta: "fiesta over",
    police: "POLICE! JUMP!",
    plusFiesta: "+FIESTA",
    enrage: "ENRAGED!",
    embiste: "CHARGE!",
    karate: "KARATE CHOP!",
    machete: "MACHETE SLASH!",
    maraca: "MARACAS!",
    spin: "SPIN!",
    headbutt: "HEADBUTT!",
    rock: "ROCK THROW!",
    ball: "KICK!",
    notes: "MUSIC NOTES!",
    fritanga: "FRITANGA THROW!",
    nacatamal: "NACATAMAL THROW!",
    coconut: "COCONUT!",
    bread: "BREAD SMASH!",
    electric: "RIGHT HOOK!",
    hypno: "HYPNOTIZE PUNCH!",
    carriage: "CARRIAGE! JUMP!",
    tuktuk: "TUK TUK! JUMP!",
    maypole: "MAYPOLE! JUMP!",
    moto: "MOTO! JUMP!",
    adHere: "ADS HERE",
    adSub: "your brand · nicabros.com",
  },
};
